import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Vision from "../components/Vision";
import Insights from "../components/Insights";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-ink" data-testid="page-home">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Vision />
        <Insights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
